export default __webpack_public_path__ + "static/media/gallery-wip-crystal_01.4d8fb30b.jpg";